import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ReferEarnService } from '@app/refer-and-earn/refer-earn.service';
import { AlertService } from '@service/alert.service';
import { AuthService } from '@service/auth.service';
import { FireAnalyticsService } from '@service/fire-analytics.service';
import { Subject, finalize, takeUntil } from 'rxjs';

@Component({
  selector: 'app-claim-reward',
  templateUrl: './claim-reward.component.html',
  styles: [
  ]
})
export class ClaimRewardComponent implements OnInit {

  showTransaction: boolean = false
  upiId = new FormControl('', Validators.compose([Validators.required, Validators.pattern(new RegExp('[a-zA-Z0-9\.\-]{2,256}\@[a-zA-Z][a-zA-Z]{2,64}'))]))
  name = new FormControl('', Validators.required);
  currentUser: any
  isExist: boolean  = false
  disabledBtn: boolean = false
  _unsubcribeData: Subject<any> = new Subject()
  transaction: any = {
    pending: false,
    success: false,
    failed: false
  }
  reward: any
  constructor(
    private dialogRef: MatDialogRef<ClaimRewardComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private referEarnService: ReferEarnService,
    private analytics: FireAnalyticsService,
    private alertService: AlertService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.getCurrentUser()
    if(this.data){
      this.reward = this.data.reward
      if (this.currentUser.name) {
        this.name.patchValue(this.currentUser.name)
      }
      if (this.currentUser.razorpay.fundAccountVPA) {
        this.upiId.patchValue(this.currentUser.razorpay.fundAccountVPA)
      }
      if(this.name.value && this.upiId.value){
        this.isExist = true
      }
    }
  }
  getCurrentUser(){
    this.authService.userProfile.pipe(takeUntil(this._unsubcribeData)).subscribe((res)=>{
      this.currentUser = res || {}
    })
  }
  closeDialog(){
    this.dialogRef.close()
  }

  goToSupport(){
    this.closeDialog()
    this.router.navigate(['/faq'])
  }

  saveUserDetail() {
    const data = {
      name: this.name.value.replace(/\s+/g, ' ').trim(),
      vpa: this.upiId.value.trim()
    }
    this.referEarnService.rewardToBank(data).subscribe(
      (res) => {
        this.analytics.logEvents('Save UPI Data')
        // this.alertService.success(res.message);
        this.authService.UpdateUserData(false);
        this.currentUser.isEditVpa = false;
        this.isExist = true
        this.getCurrentUser()
      },
      (err: any) => {
        this.currentUser.isEditVpa = false;
      }
    )
  }
  claimReward() {
    this.data.isMultiple ? this.claimMultipleReward() : this.claimSingleReward()
  }

  claimSingleReward(){
    this.disabledBtn = true
    let data = {
      rewardId: this.reward._id
    }
    this.referEarnService.claimReward(data).pipe(takeUntil(this._unsubcribeData) ,finalize(() => this.disabledBtn = false)).subscribe(
      (res) => {
        this.showTransaction = true
        this.transaction.success = true
      },
      (err: any) => {
        this.showTransaction = true
        this.transaction.failed = true
      }
    )
  }

  claimMultipleReward(){
    let value = {
      rewardIds: this.data.rewardIds
    }
    this.referEarnService.claimMultipleReward(value).pipe(takeUntil(this._unsubcribeData), finalize(()=> this.disabledBtn = false)).subscribe(
      (res) => {
        this.showTransaction = true
        this.transaction.success = true
      },
      (err: any) => {
        this.showTransaction = true
        this.transaction.failed = true
      })
  }
}
